import axios from 'axios';
import { AxiosResponse } from 'axios';
import { ParticleOneASHRAEFlowRateResponse } from '../models/ParticleOneASHRAEFlowRateResponse';

export default {
  async getSuggestedFlowRate(space_id: string | number) {
    const response: AxiosResponse<ParticleOneASHRAEFlowRateResponse> = await axios.get(`/spaces/${space_id}/ashrae-flow-rates/`);
    return response.data;
  }
};